import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  MaterialLayoutSchema,
  ProcessStepSchema,
  ProductLineSchema,
  ProductSchema,
  ProductTypeSchema,
} from "../types";
import { makeCreateInputSchema } from "../utils/zod-utils/makeCreateInputSchema";
import { makeUpdateInputSchema } from "../utils/zod-utils/makeUpdateInputSchema";

const c = initContract();

export const processStepsContract = c.router({
  create: {
    method: "POST",
    path: "/process-steps",
    body: makeCreateInputSchema(
      ProcessStepSchema.omit({ alerts: true, isFixedCostManuallyEdited: true }),
    ).extend({
      productLines: z
        .array(
          ProductLineSchema.omit({
            id: true,
            createdAt: true,
            updatedAt: true,
            processStepId: true,
            productId: true,
            quoteRequestId: true,
            quoteRequestLineId: true,
          })
            .partial()
            .extend({
              name: z.string(),
              quantity: z.number(),
              price: z.number(),
              product: ProductSchema.pick({
                id: true,
                name: true,
                price: true,
                fixedPrice: true,
                type: true,
              }).extend({
                id: z.string().optional(),
                type: ProductTypeSchema.optional(),
                fixedPrice: z.number().int().nullable().optional(),
              }),
            }),
        )
        .optional(),
      materialLayout: makeCreateInputSchema(MaterialLayoutSchema).optional(),
    }),
    responses: {
      200: ProcessStepSchema.extend({
        materialLayout: MaterialLayoutSchema.nullable(),
        productLines: ProductLineSchema.array(),
      }),
    },
  },

  update: {
    method: "PUT",
    path: "/process-steps/:id",
    body: ProcessStepSchema.omit({
      id: true,
      createdAt: true,
      updatedAt: true,
      alerts: true,
      isFixedCostManuallyEdited: true,
    })
      .partial()
      .extend({
        productLines: makeUpdateInputSchema(
          ProductLineSchema.merge(z.object({ product: ProductSchema })),
        )
          .array()
          .optional(),
      }),
    responses: {
      200: ProcessStepSchema,
    },
  },

  delete: {
    method: "DELETE",
    path: "/process-steps/:id",
    body: z.object({}),
    responses: {
      200: z.object({}),
    },
  },
});
